function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { number as locale } from './locale';
import isAbsent from './util/isAbsent';
import BaseSchema from './schema';
var isNaN = function(value) {
    return value != +value;
};
export function create() {
    return new NumberSchema();
}
var NumberSchema = /*#__PURE__*/ function(BaseSchema) {
    "use strict";
    _inherits(NumberSchema, BaseSchema);
    function NumberSchema() {
        _class_call_check(this, NumberSchema);
        var _this;
        _this = _call_super(this, NumberSchema, [
            {
                type: 'number'
            }
        ]);
        _this.withMutation(function() {
            _this.transform(function(value) {
                var parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
        return _this;
    }
    _create_class(NumberSchema, [
        {
            key: "_typeCheck",
            value: function _typeCheck(value) {
                if (_instanceof(value, Number)) value = value.valueOf();
                return typeof value === 'number' && !isNaN(value);
            }
        },
        {
            key: "min",
            value: function min(min) {
                var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : locale.min;
                return this.test({
                    message: message,
                    name: 'min',
                    exclusive: true,
                    params: {
                        min: min
                    },
                    test: function test(value) {
                        return isAbsent(value) || value >= this.resolve(min);
                    }
                });
            }
        },
        {
            key: "max",
            value: function max(max) {
                var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : locale.max;
                return this.test({
                    message: message,
                    name: 'max',
                    exclusive: true,
                    params: {
                        max: max
                    },
                    test: function test(value) {
                        return isAbsent(value) || value <= this.resolve(max);
                    }
                });
            }
        },
        {
            key: "lessThan",
            value: function lessThan(less) {
                var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : locale.lessThan;
                return this.test({
                    message: message,
                    name: 'max',
                    exclusive: true,
                    params: {
                        less: less
                    },
                    test: function test(value) {
                        return isAbsent(value) || value < this.resolve(less);
                    }
                });
            }
        },
        {
            key: "moreThan",
            value: function moreThan(more) {
                var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : locale.moreThan;
                return this.test({
                    message: message,
                    name: 'min',
                    exclusive: true,
                    params: {
                        more: more
                    },
                    test: function test(value) {
                        return isAbsent(value) || value > this.resolve(more);
                    }
                });
            }
        },
        {
            key: "positive",
            value: function positive() {
                var msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : locale.positive;
                return this.moreThan(0, msg);
            }
        },
        {
            key: "negative",
            value: function negative() {
                var msg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : locale.negative;
                return this.lessThan(0, msg);
            }
        },
        {
            key: "integer",
            value: function integer() {
                var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : locale.integer;
                return this.test({
                    name: 'integer',
                    message: message,
                    test: function(val) {
                        return isAbsent(val) || Number.isInteger(val);
                    }
                });
            }
        },
        {
            key: "truncate",
            value: function truncate() {
                return this.transform(function(value) {
                    return !isAbsent(value) ? value | 0 : value;
                });
            }
        },
        {
            key: "round",
            value: function round(method) {
                var _method;
                var avail = [
                    'ceil',
                    'floor',
                    'round',
                    'trunc'
                ];
                method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc
                if (method === 'trunc') return this.truncate();
                if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
                return this.transform(function(value) {
                    return !isAbsent(value) ? Math[method](value) : value;
                });
            }
        }
    ]);
    return NumberSchema;
}(BaseSchema);
export { NumberSchema as default };
create.prototype = NumberSchema.prototype; //
 // Number Interfaces
 //
